import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import router from "@/router";

import registration from "./modules/registration.js";
import user from "./modules/user.js";
import login from "./modules/login.js";
import profile from "./modules/profile.js";
import common from "./modules/common.js";
import bid from "./modules/bid.js";
import billing from "./modules/billing.js";
import server, { addErrorHandler } from "@/api/server.js";
import reports from "./modules/reports.js";
import team from "./modules/team.js";
import user_transfer from "./modules/user_transfer.js";
import employes from "./modules/employes.js";
import meeting from "./modules/meeting.js";
import payouts from "./modules/payouts.js";
import user_notification from "./modules/user_notification.js";
import app from "./modules/app.js";

const store = new Vuex.Store({
  actions: {
    reset({ commit }) {
      commit("login/reset");
      commit("user/reset");
      commit("registration/reset");
      commit("profile/reset");
      commit("bid/reset");
      commit("billing/reset");
      commit("common/reset");
      commit("reports/reset");
      commit("team/reset");
      commit("user_transfer/reset");
      commit("employes/reset");
      commit("meeting/reset");
      commit("payouts/reset");
      commit("user_notification/reset");
      commit("app/reset");
    },
  },
  modules: {
    login,
    user,
    common,
    registration,
    profile,
    bid,
    billing,
    reports,
    team,
    user_transfer,
    employes,
    meeting,
    payouts,
    user_notification,
    app,
  },
  strict: process.env.NODE_ENV !== "production",
});

server.interceptors.request.use(
  function (config) {
    if (config.hideLoader !== true) {
      store.commit("common/startLoading");
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

addErrorHandler(
  ({ data, config }) => {
    if (config.hideLoader !== true) {
      store.commit("common/stopLoading");
    }

    // прокидываем нормальный ответ
    if (data?.status === "ok")
    {
      if (!config.dontLog) {
        console.log("Ответ сервера:", data);
      }

      //сохраняем доступы
      if (data?.access) {
        store.commit("profile/setAccess", data.access);
      }

      return data.response ?? true;
    }

    // Обработка ошибок:

    // Не авторизован
    if (data.err === "unauthorized") {
      const loginPath = "/account/login";
      if (router.currentRoute.path !== loginPath) {
        router.push({ path: loginPath });
      }

      return null;
    }

    // Компания с таким огрн уже зарегана, показываем предупреждение (Рега)
    if (data.err === "agent.this_company_already_exists") {
      commit("profile/setOgrnExist", true);

      return null;
    }

    // Остальные ошибки
    if (data.errdesc) {
      store.commit("common/setErrdesc", data.errdesc);
      store.dispatch("common/addAlert", { msg: data.errdesc, type: "error" });

      return null;
    }

    // Обработка редиректа
    if (data?.status === "redirect") {
      let { url, message } = data.response;
      if (url[0] != "/") url = "/" + url;
      if (message) {
        store.commit("common/setRedirect", { url, message });
      } else {
        router.push(url);
      }

      return null;
    }

    store.dispatch("common/addAlert", { msg: "Неожиданный ответ сервера", type: "error" });

    return null;
  },
  (error) => {
    if (error.config.hideLoader !== true) {
      store.commit("common/stopLoading");
    }

    if (error.response) {
      store.dispatch("common/addAlert",
        { msg: `Ошибка ${error.response.status}`, type: "error" });
    } else if (error.request) {
      store.dispatch("common/addAlert", { msg: "Не удалось получить ответ от сервера", type: "error" });
    } else {
      store.dispatch("common/addAlert", { msg: "Что-то пошло не так", type: "error" });
    }
    console.error(error);
  }
);

export default store;
